<template>
  <div>
    <modal
      ref="creditRequestModal"
      template="neutral"
      ref-name="creditRequestModal"
      class="credit-request-modal"
      :close-button-enabled="true"
    >
      <div class="credit-request-modal__wrapper">
        <h2 class="title">
          Solicitação de Crédito
        </h2>
        <p class="description">
          <img
            src="../../../../static/images/icon-info-2.svg"
            alt="icone de informação"
          >
          Em caso de pagamento via pix e boleto o tempo para provisionamento em conta será automático.
        </p>

        <Spinner v-if="loading" />
        <form v-else>
          <div class="form-wrapper">
            <p>Insira a forma de pagamento e o valor a ser solicitado:</p>
            <div class="box">
              <SelectDefault
                :data-list="methodsPaymentList"
                :initial-value="methodOfPayment"
                @valueSelected="getValue"
              />
              <input
                v-model="value"
                placeholder="Valor"
                type="text"
                @input="formatMoney"
              >
            </div>
          </div>

          <button
            :disabled="!methodOfPayment || !value"
            :class="{ enabled: methodOfPayment && value }"
            @click.prevent="handleCreateCreditRequest"
          >
            Continuar
          </button>
        </form>
      </div>

      <div class="footer">
        <p>
          Em caso de pagamentos no boleto é necessário aguardar provisionamento e liberação do pagamento conforme o
          banco.
        </p>
      </div>
    </modal>

    <PaymentRequestModal
      v-if="showPaymentRequestModal"
      :payment="payment"
      @close="handleCloseModal"
    />
  </div>
</template>

<script>
import notify from '../../../api/notification'
import payments from '../../../api/payments'
import { formatCurrencyDecimal, removeFormatCurrency } from '../../../utils/format-currency'
import SelectDefault from '../../common/SelectDefault.vue'
import Spinner from '@/components/common/Spinner'
import PaymentRequestModal from './PaymentRequestModal.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CreditRequestModal',
  components: {
    SelectDefault,
    PaymentRequestModal,
    Spinner
  },
  data: () => {
    return {
      accountId: '',
      methodOfPayment: null,
      value: '',
      formattedValue: '',
      loading: false,
      payment: null,
      showPaymentRequestModal: false,
      methodsPaymentList: {
        id: 'report-type-select',
        label: '',
        placeholder: 'Forma de pagamento',
        options: [
          {
            name: 'boleto',
            text: 'Boleto',
            id: 1
          },
          // {
          //   name: 'pix',
          //   text: 'Pix',
          //   id: 2
          // }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['toggle'])
  },
  mounted() {
    if (this.toggle.prePaid) {
      payments
        .findAccountByEntityId('PREPAID')
        .then(({ data }) => {
          this.accountId = data.accountId
        })
        .catch(error => {
          console.error('Error on find account by entity id', error)
        })
    }
  },
  methods: {
    handleCloseModal() {
      this.showPaymentRequestModal = false
      this.$emit('payment-requested')
      this.$emit('modal-closed')
    },
    getValue(value) {
      this.methodOfPayment = value
    },
    handleOpenCreditRequestModal() {
      this.$refs.creditRequestModal.open()
    },
    async handleCreateCreditRequest() {
      this.loading = true

      try {
        const { data } = await payments.createRequestPayment(
          {
            methodOfPayment: this.methodOfPayment.id,
            value: removeFormatCurrency(this.value)
          },
          this.accountId
        )
        const { value, paymentId } = data

        this.payment = {
          paymentLink: `/payments/${paymentId}`,
          amount: value,
          paymentId: paymentId,
          status: 'Pending',
          createdAt: new Date(),
          paymentMethod: {
            type: this.methodOfPayment.name,
            id: this.methodOfPayment.id
          }
        }
        this.$refs.creditRequestModal.close()
        this.showPaymentRequestModal = true

        this.$emit('modal-closed')
      } catch (error) {
        const { response } = error?.response?.data

        if (JSON.parse(response)) {
          const { title, detail } = JSON.parse(response)

          notify({ title, message: detail })
        }
      } finally {
        this.loading = false
      }
    },
    formatMoney(event) {
      let rawValue = event.target.value.replace(/\D/g, '')

      if (!rawValue) {
        this.value = ''
        return
      }

      this.value = formatCurrencyDecimal(rawValue)
    }
  }
}
</script>

<style lang="scss">
  .credit-request-modal {
    max-width: 501px;
    margin: 0 auto;

    .form-wrapper {
      p {
        margin-bottom: 16px;
      }

      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input {
        border: 1px solid #cccccc;
        border-radius: 4px;
        padding-left: 8px;
        height: 40px;
        width: 188px;
      }

      .box {
        display: flex;
        gap: 16px;
      }
    }

    form {
      flex-direction: column;
      display: flex;
      align-items: center;

      button {
        width: 122px;
        height: 40px;
        margin-top: 26px;
        text-transform: uppercase;
        background-color: #757575;

        &.enabled {
          background-color: #7f1a54;
        }
      }
    }

    .footer {
      background-color: #dadada;
      padding: 17px 50px;
      text-align: center;
      font-size: 11px;
    }

    .title {
      color: #595959;
      font-size: 18px;
      margin-bottom: 16px;
    }

    .description {
      margin-bottom: 16px;
      display: flex;
      align-items: flex-start;

      img {
        margin-right: 2px;
      }
    }

    .md-dialog {
      min-height: 275px !important;
      max-height: 84% !important;

      &-content,
      &-title {
        padding: 0;

        .close-button {
          z-index: 2;
        }
      }

      .standard-modal__title {
        display: none;
      }
    }

    &__wrapper {
      font-family: 'Exo 2', sans-serif !important;
      padding: 30px 50px;
    }
  }
</style>
